const defaultState = {
  customer: null,
  shippingMethods: [],
  paymentMethods: [],
  desiredDeliveryDays: [],
  desiredDeliveryTimeZone: [],
}

export default {
  namespaced: true,
  state: () => ({
    ...defaultState,
  }),

  mutations: {
    SET_CUSTOMER(state, data) {
      state.customer = data
    },

    REMOVE_CUSTOMER(state) {
      state.customer = null
    },

    SET_SHIPPING_METHODS(state, data) {
      state.shippingMethods = data
    },

    SET_PAYMENT_METHODS(state, data) {
      state.paymentMethods = data
    },

    SET_DESIRED_DELIVERY_DAYS(state, data) {
      state.desiredDeliveryDays = data
    },

    SET_DESIRED_DELIVERY_TIME_ZONE(state, data) {
      state.desiredDeliveryTimeZone = data
    },

    RESET_INFO(state) {
      state.customer = defaultState.customer
      state.shippingMethods = defaultState.shippingMethods
      state.paymentMethods = defaultState.paymentMethods
      state.desiredDeliveryDays = defaultState.desiredDeliveryDays
      state.desiredDeliveryTimeZone = defaultState.desiredDeliveryTimeZone
    },
  },
}
